module.exports = __webpack_public_path__ + "img/share--green.0c5a0b2e.svg";